import APIUtils from '@spothero/utils/api';

const DestinationAPI = {
    get(id) {
        return APIUtils.get(`destinations/${id}/`);
    },
};

export default DestinationAPI;
